// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Reservation list (scrollable)
// ---------------------------------------------------------------------------

import type { Reservation } from '@/lib/types';
import ReservationCard from '@/components/ReservationCard';

interface ReservationListProps {
  reservations: Reservation[];
  onSelect: (reservation: Reservation) => void;
}

export default function ReservationList({ reservations, onSelect }: ReservationListProps) {
  if (reservations.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-gray-400">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="mb-3 opacity-50">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        <p className="text-sm">Aucune reservation trouvee</p>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto pb-4">
      {reservations.map((resa) => (
        <ReservationCard
          key={resa.id}
          reservation={resa}
          onClick={() => onSelect(resa)}
        />
      ))}
    </div>
  );
}
